import React, { Component } from 'react';
import { Card, Button, Col, Form, Row, Spinner, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../../Helpers/fetcher.js";
import ReactTooltip from 'react-tooltip';
import DatePicker from "react-datepicker";
import Cookies from 'js-cookie';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";

import FileViewer from './FileViewer.js';

class VoiceBase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewVoiceBase: [],
            startDate: new Date(),
            endDate: new Date(),
            sizePerPage: 10,
            showTable: false,
            fileViewerUrl: null,
            campaignId: "",
            campaignName: "",
            showCampaignModal: false,
            loadingCampaignNames: false
        };
    }

    componentDidMount() {
        const savedSizePerPage = Cookies.get('creditListsizePerPage');
        if (savedSizePerPage) {
            this.setState({ sizePerPage: Number(savedSizePerPage) });
        }
        this.fetchVoiceBase();
    }

    formatDate = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    };

    setvalue = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };


    handleStartDateChange = (date) => {
        const maxEndDate = new Date(date);
        maxEndDate.setDate(maxEndDate.getDate() + 7);

        let newEndDate = this.state.endDate;
        if (newEndDate < date) newEndDate = date;
        if (newEndDate > maxEndDate) newEndDate = maxEndDate;

        this.setState({
            startDate: date,
            endDate: newEndDate
        });
    };

    handleEndDateChange = (date) => {
        this.setState({ endDate: date });
    };


    fetchVoiceBase = async () => {
        const { startDate, endDate, campaignId } = this.state;
        const apiPath = this.props.app.apiPath;

        const data = {
            startDate: this.formatDate(startDate),
            endDate: this.formatDate(endDate),
            campaignIds: campaignId || ""
        };

        this.setState({ showTable: false });

        try {
            const res = await Fetcher.post(
                apiPath + '/api/obd/get/voice/base',
                {
                    headers: { "Content-type": "application/json" },
                    method: 'POST',
                    body: JSON.stringify(data)
                }
            );

            this.setState({
                viewVoiceBase: res,
                showTable: true
            });
        } catch (err) {
            console.log('Error in fetching Voice Base', err);
        }
    };

    fetchDetailwithBaseId = async (id) => {
        const apiPath = this.props.app.apiPath;

        this.setState({ loadingCampaigns: true, showCampaignModal: true });

        try {
            const res = await Fetcher.get(apiPath + `/api/obd/base/camapaign/`+id)
            if (res.error) return
            this.setState({
                campaignName: res.camapignName,
                loadingCampaigns: false
            });
        } catch (err) {
            console.log('Error in fetching Detail with Base id', err);
        } finally {
            this.setState({ loadingCampaigns: false });
        }
    }

    searchCdr = (e) => {
        e.preventDefault();
        this.fetchVoiceBase();
    };

    applyCampaignFilter = () => {
        this.fetchVoiceBase();
    };


    handleSizePerPageChange = (newSizePerPage) => {
        this.setState({ sizePerPage: newSizePerPage });
        Cookies.set('creditListsizePerPage', newSizePerPage);
    };

    handleView = (url) => {
        if (url) this.setState({ fileViewerUrl: url });
    };

    handleCampaignNameView = (id) => {
        if (id) this.fetchDetailwithBaseId(id)
    };

    closeFileViewer = () => {
        this.setState({ fileViewerUrl: null });
    };

    closeCampaignModal = () => {
        this.setState({
            showCampaignModal: false,
            campaignName: ""
        });
    };

    render() {
        const { ExportCSVButton } = CSVExport;
        const viewVoiceBase = Array.isArray(this.state.viewVoiceBase)
            ? this.state.viewVoiceBase
            : [];

        const columns = [
            { dataField: 'baseId', text: 'Base Id', sort: true },
            { dataField: 'baseName', text: 'Base Name' },
            {
                dataField: 'Campaign Name',
                text: 'Campaign Name',
                isDummyField: true,
                csvExport: false,
                formatter: (_, row) => (
                    <button
                        className="btn btn-link py-0"
                        onClick={() => this.handleCampaignNameView(row.baseId)}
                    >
                        View
                    </button>
                )
            },
            { dataField: 'userId', text: 'User Id', sort: true },
            { dataField: 'username', text: 'Username' },
            { dataField: 'totalNumbers', text: 'Total Numbers', sort: true },
            { dataField: 'uploadDate', text: 'Upload Date', sort: true },
            {
                dataField: 'baseUrl',
                text: 'Action',
                formatter: (_, row) => (
                    <button
                        className="btn btn-link py-0"
                        onClick={() => this.handleView(row.baseUrl)}
                    >
                        View
                    </button>
                )
            }
        ];

        const users = viewVoiceBase.map(u => ({
            baseId: u.baseId,
            baseName: u.baseName,
            userId: u.userId,
            username: u.username,
            totalNumbers: u.totalNumbers,
            uploadDate: u.uploadDate,
            baseUrl: u.baseUrl
        }));

        const paginationOption = {
            custom: true,
            totalSize: users.length,
            sizePerPage: this.state.sizePerPage,
            sizePerPageList: [10, 25, 50, 100],
            onSizePerPageChange: this.handleSizePerPageChange
        };

        return (
            <>
                <Card>
                    <Card.Header>Voice Base</Card.Header>
                    <Card.Body>
                        <Form onSubmit={this.searchCdr}>
                            <Row>
                                <Col sm={2}>
                                    <DatePicker
                                        className="form-control"
                                        dateFormat="yyyy-MM-dd"
                                        selected={this.state.startDate}
                                        onChange={this.handleStartDateChange}
                                    />
                                </Col>

                                <Col sm={2}>
                                    <DatePicker
                                        className="form-control"
                                        dateFormat="yyyy-MM-dd"
                                        selected={this.state.endDate}
                                        onChange={this.handleEndDateChange}
                                        minDate={this.state.startDate}
                                        maxDate={
                                            new Date(
                                                new Date(this.state.startDate).setDate(
                                                    this.state.startDate.getDate() + 7
                                                )
                                            )
                                        }
                                    />
                                </Col>

                                <Col sm={2}>
                                    <Button type="submit">Search</Button>
                                </Col>
                            </Row>

                            <Row className="my-3">
                                <Col sm={2}>
                                    <Form.Control
                                        placeholder="Campaign Id"
                                        type="number"
                                        name="campaignId"
                                        onChange={this.setvalue}
                                    />
                                </Col>

                                <Col sm={2}>
                                    <Button type="button" onClick={this.applyCampaignFilter}>
                                        Apply
                                    </Button>
                                </Col>
                            </Row>
                        </Form>

                        {this.state.showTable ? (
                            <PaginationProvider pagination={paginationFactory(paginationOption)}>
                                {({ paginationProps, paginationTableProps }) => (
                                    <ToolkitProvider
                                        keyField="baseId"
                                        data={users}
                                        columns={columns}
                                        search
                                        bootstrap4
                                        exportCSV={{ fileName: 'voice-base.csv' }}
                                    >
                                        {props => (
                                            <>
                                                Show <SizePerPageDropdownStandalone {...paginationProps} />
                                                <ExportCSVButton
                                                    className="btn btn-primary float-right"
                                                    {...props.csvProps}
                                                >
                                                    Export CSV
                                                </ExportCSVButton>

                                                <BootstrapTable
                                                    hover
                                                    bordered
                                                    condensed
                                                    wrapperClasses="table-responsive mt-2"
                                                    classes="widgetlist-table"
                                                    {...props.baseProps}
                                                    {...paginationTableProps}
                                                    noDataIndication="No data available"
                                                />

                                                <PaginationListStandalone {...paginationProps} />
                                                <ReactTooltip />
                                            </>
                                        )}
                                    </ToolkitProvider>
                                )}
                            </PaginationProvider>
                        ) : (
                            <div className="loader">
                                <Spinner animation="border" variant="primary" />
                            </div>
                        )}
                    </Card.Body>
                </Card>

                <Modal
                    show={this.state.showCampaignModal}
                    onHide={this.closeCampaignModal}
                    size="sm"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Campaign Names</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div style={{ maxHeight: '220px', overflowY: 'auto' }}>
                            {this.state.loadingCampaignNames ? (
                                <div className="text-center my-3">
                                    <Spinner animation="border" variant="primary" />
                                </div>
                            ) : this.state.campaignName ? (
                                this.state.campaignName
                                    .split(',')
                                    .map((name, index) => (
                                        <div key={index} style={{ marginBottom: '5px', wordBreak: 'break-word' }}>
                                            <strong>Campaign Name:</strong> {name.trim()}
                                        </div>
                                    ))
                            ) : (
                                <div className="text-center text-muted">
                                    No campaigns available
                                </div>
                            )}
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="justify-content-center">
                        <Button variant="secondary" onClick={this.closeCampaignModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                {this.state.fileViewerUrl && (
                    <FileViewer
                        url={this.state.fileViewerUrl}
                        onClose={this.closeFileViewer}
                    />
                )}
            </>
        );
    }
}

export default VoiceBase;